"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var winkEgg = {
    name: "wink",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["w", "i", "n", "k"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://weichiachang.github.io/easter-eggs-mobile/images/wink.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "300px";
        img.style.height = "300px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 300px)";
        img.style.bottom = "-600px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "0px";
        }, 30);
        window.setTimeout(function () {
            img.style.bottom = "-600px";
        }, 4300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
            shock.parentNode.removeChild(shock);
        }, 5400);
    },
};
exports.default = winkEgg;
